module.exports = __webpack_public_path__ + "static/img/no_items.47e756f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_items.png
// module id = 188
// module chunks = 7